import { Button } from "@components/Button"
import { useNavigate } from "react-router-dom"
import ProfileMenu from "../ProfileMenu/ProfileMenu"
import { RiCalendarScheduleLine } from 'react-icons/ri';
import { CircularProgress } from '@mui/material';
import ButtonComponent from "@components/ButtonComponent";


const Navbar = ({
  title,
  onSaveAndNext,
  onSchedule,  // New prop for schedule button action
  isSaving = false,
  showBack = true,
  showLoadAdCopy = false,
  onLoadAdCopy,
  showSaveAndNext = true,
  showSchedule = false,  // New prop to control schedule button visibility
  saveButtonText = "Save and Next",
  scheduleButtonText = "",  // Default text for schedule button
  adAccountName = null,
  loading = false,
}) => {
  const navigate = useNavigate()

  const handleSaveAndNext = () => {
    onSaveAndNext()
  }

  const handleSchedule = () => {
    onSchedule()
  }

  return (
    <div className="flex items-center justify-between pb-3 mb-6 border-b border-gray-200">
      <h1 className="text-3xl font-bold tracking-tight text-gray-800">
        {title}
      </h1>
      {adAccountName && (
        <p className="text-gray-700">Ad Account: <span className="font-semibold">{adAccountName}</span></p>
      )}
      <div className="flex items-center gap-4">
        {showBack && (
          <Button
            onClick={() => navigate(-1)}
            className="text-gray-600 bg-gray-200 hover:bg-gray-300"
            text="Back"
          />
        )}
        {showLoadAdCopy && (
          <Button
            onClick={onLoadAdCopy}
            className="bg-emerald-600 hover:bg-emerald-700 border"
            text="Load Ad Copy"
          />
        )}
        {showSchedule && onSchedule && (
          <Button
            onClick={handleSchedule}
            className="px-4 py-2 text-white rounded-md bg-emerald-600 hover:bg-emerald-700 h-11"
            text={scheduleButtonText}
            prependIcon={<RiCalendarScheduleLine />}
            size={"text-xl"}
          />
        )}
        {showSaveAndNext && (
          <Button
            onClick={handleSaveAndNext}
            className="text-white bg-emerald-600 hover:bg-emerald-700"
            text={loading ? "Publishing..." : saveButtonText}
            disabled={loading}
            prependIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
          />
        )}
        <ProfileMenu />
      </div>
    </div>
  )
}

export default Navbar